module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-9.jpg?v=491da11e";